// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Tiktok: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 17 20"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M17 8.198a7.822 7.822 0 01-4.66-1.533v6.98c-.002 4.887-5.145 7.939-9.257 5.494-4.112-2.445-4.11-8.554.004-10.996a6.025 6.025 0 013.93-.789v3.51c-2.08-.672-4.088 1.224-3.615 3.413.474 2.19 3.074 3.032 4.68 1.515.585-.552.918-1.331.918-2.147V0h3.34c-.002.29.021.58.07.866a4.779 4.779 0 002.047 3.133A4.517 4.517 0 0017 4.785v3.413z" />
        </svg>
    );
};

export default React.memo(Tiktok);
